import * as _ from 'lodash';
import { maxiileSize } from './constants';

export const getFileExtension = fileName => {
  return fileName
    .split('.')
    .pop()
    .toLowerCase();
};

/**
 * @description ファイルタイプチェック
 * @param {*} buf 画像情報
 * @param {string} fileName ファイル名
 */
export const fileType = (buf, fileName) => {
  const fileExtension = getFileExtension(fileName);
  let arr = new Uint8Array(buf).subarray(0, 4);
  let header = '';
  for (let i = 0; i < arr.length; i++) {
    header += arr[i].toString(16);
  }
  if (header.match(/^89504e47/) && fileExtension === 'png') {
    return { ext: 'png' };
  }
  if (header.match(/^47494638/) && fileExtension === 'gif') {
    return { ext: 'gif' };
  }
  if (header.match(/^424d/) && fileExtension === 'bmp') {
    return { ext: 'bmp' };
  }
  if (
    header.match(/^ffd8ff/) &&
    (fileExtension === 'jpg' || fileExtension === 'jpeg')
  ) {
    return { ext: 'jpg' };
  }
  if (header.match(/^d0cf11e0/) && fileExtension === 'doc') {
    return { ext: 'doc' };
  }
  if (header.match(/^d0cf11e0/) && fileExtension === 'ppt') {
    return { ext: 'ppt' };
  }
  if (header.match(/^d0cf11e0/) && fileExtension === 'xls') {
    return { ext: 'xls' };
  }
  if (header.match(/^504b34/) && fileExtension === 'xlsx') {
    return { ext: 'xlsx' };
  }
  if (header.match(/^504b34/) && fileExtension === 'docx') {
    return { ext: 'docx' };
  }
  if (header.match(/^504b34/) && fileExtension === 'pptx') {
    return { ext: 'pptx' };
  }
  if (header.match(/^25504446|efbbbf25/) && fileExtension === 'pdf') {
    return { ext: 'pdf' };
  }
  if (
    header.match(/^4d4d2a0|49492a0|4d4d02a|494902a/) &&
    (fileExtension === 'tif' || fileExtension === 'tiff')
  ) {
    return { ext: 'tif' };
  }
  return { ext: null };
};

export const fileTypeCheck = async (
  file,
  allowExts = ['jpg', 'png', 'gif']
) => {
  let promise = new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = e => {
      const result = fileType(e.target.result, file.name);
      if (_.isArray(allowExts) && allowExts.includes(result.ext)) {
        resolve(true);
      } else {
        resolve(false);
      }
    };
    reader.readAsArrayBuffer(file);
  });
  return promise;
};

export const fileTypeCheckImagePDF = async file => {
  let promise = new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = e => {
      const result = fileType(e.target.result, file.name);
      if (
        result.ext == 'jpg' ||
        result.ext == 'png' ||
        result.ext == 'gif' ||
        result.ext == 'bmp' ||
        result.ext == 'tif' ||
        result.ext == 'pdf'
      ) {
        resolve(true);
      } else {
        resolve(false);
      }
    };
    reader.readAsArrayBuffer(file);
  });
  return promise;
};

/**
 * @description 選択ファイルのタイプをチェック
 * @param {*} file 選択ファイル
 * @param {array} approvalFileType 承認ファイル拡張子
 */
export const approvalFileType = async (file, approvalFileType) => {
  let promise = new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = e => {
      const result = fileType(e.target.result, file.name);
      if (_.some(approvalFileType, type => type === result.ext)) {
        resolve(true);
      } else {
        resolve(false);
      }
    };
    reader.onerror = function() {
      reject(false);
    };
    reader.readAsArrayBuffer(file);
  });
  return promise;
};

export const fileSizeCheck = async (file, size = maxiileSize) => {
  let promise = new Promise(resolve => {
    if (file.size > size) {
      resolve(false);
    } else {
      resolve(true);
    }
  });
  return promise;
};

/**
 * @description 選択ファイルのサイズをチェック
 * @param {*} file 選択ファイル
 * @param {number} maxfileSize 上限ファイルサイズ(バイト)
 */
export const dynamicFileSizeCheck = async (file, maxfileSize) => {
  let promise = new Promise(resolve => {
    if (file.size > maxfileSize) {
      resolve(false);
    } else {
      resolve(true);
    }
  });
  return promise;
};

/**
 * @description 選択ファイルにファイル名が存在するか判定する
 * @param {*} file 選択ファイル
 * @return {Promise} 
 */
export const hasfileName = async file => {
  let promise = new Promise(resolve => {
    const extension = file.name.lastIndexOf('.')
      if (extension === 0) {
        resolve(false);
      } else {
        resolve(true);
      }
  });
  return promise;
};



// WEBPACK FOOTER //
// ./src/utilities/fileType.js